import { formatToShortDate } from "utils/format";
import "./index.scss";
import { useAppContext } from "context/app-context";
import { useBrandRating } from "./utils/useBrandRating";

export const BrandRating = (props) => {
  const {
    rating: { updatedAt }
  } = props;
  const {
    sessionInfo: { isLoggedIn }
  } = useAppContext();
  const { hasVoted, ratingMessage, makeStars, rateBrand } =
    useBrandRating(props);

  const handleStarClick = async (value) => {
    if (!isLoggedIn) return null;

    rateBrand(value);
  };

  const isDisabled = !isLoggedIn || hasVoted;

  return (
    <div
      className={`rating-container${isDisabled ? " disabled" : ""}`}
      data-testid="brand-rating"
    >
      <div className="stars-container">
        <ul className="stars">{makeStars(handleStarClick)}</ul>
      </div>
      <p className="rating-infos">
        <strong>{ratingMessage}</strong>
        &nbsp;
        {updatedAt && <span>Updated {formatToShortDate(updatedAt)}</span>}
      </p>
    </div>
  );
};
